import React from 'react';
import {Icon, IconButton} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from "@mui/styles";

function TooltipPersonalizado({title, fontSize, color, marginTop, handleFunction, icon}) {

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontSize: "1rem",
      color: "white",
      backgroundColor: color,
      borderRadius: 10,
      padding: '10px 5px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center'
    },
  }));

  return (
    <LightTooltip title={title}>
        <IconButton onClick={handleFunction}>
          <Icon sx={{ fontSize, color, marginTop }} >{icon}</Icon>
        </IconButton>
    </LightTooltip>
  );
}

TooltipPersonalizado.defaultProps = {
  fontSize: 50,
  color: "#205690",
  icon: "add_circle",
  handleFunction: () => {}
}

export default TooltipPersonalizado;